// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Table.LocationsTable {
  --border: 1px solid rgba(0, 0, 0, 0.15);
  width: 100%;
  min-height: calc(100vh - var(--header-height));
}
.Table.LocationsTable table {
  --sp-table-header-bg: var(--bs-secondary-subtle);
  background-color: #fff;
  border-width: 1px 0;
}
.Table.LocationsTable table .TableRow {
  display: flex;
  width: 100%;
}
.Table.LocationsTable table .TableRow + .TableRow {
  border-top: var(--border);
}
.Table.LocationsTable table .TableRow.TableRow-Header {
  border-bottom: var(--border);
}
.Table.LocationsTable table .TableRow.TableRow-Header .TableCell-Content {
  display: flex;
  justify-content: center;
  align-items: center;
}
.Table.LocationsTable table .TableRow .TableCell {
  flex: 1;
  min-width: 7rem;
}
.Table.LocationsTable table .TableRow .TableCell.SELECT {
  flex: 0 0 3rem;
  min-width: unset;
}
.Table.LocationsTable table .TableRow .TableCell.NAME {
  flex: 1.5;
}
.Table.LocationsTable table .TableRow .TableCell + .TableCell {
  border-left: var(--border);
}
.Table.LocationsTable table .TableRow .TableCell .TableCell-Content {
  padding: 0.35rem;
  align-content: center;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 700;
}
.Table.LocationsTable .Table-Controls {
  margin-right: 0.5rem;
}`, "",{"version":3,"sources":["webpack://./src/pages/Locations/LocationsTable/styles.scss"],"names":[],"mappings":"AAEA;EACE,uCAAA;EACA,WAAA;EACA,8CAAA;AADF;AAGE;EACE,gDAAA;EACA,sBAAA;EACA,mBAAA;AADJ;AAGI;EACE,aAAA;EACA,WAAA;AADN;AAEM;EACE,yBAAA;AAAR;AAGM;EACE,4BAAA;AADR;AAEQ;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AAAV;AAIM;EACE,OAAA;EACA,eAAA;AAFR;AAGQ;EACE,cAAA;EACA,gBAAA;AADV;AAGQ;EACE,SAAA;AADV;AAGQ;EACE,0BAAA;AADV;AAGQ;EACE,gBAAA;EACA,qBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;AADV;AAME;EACE,oBAAA;AAJJ","sourcesContent":["@import '../../../globals.scss';\n\n.Table.LocationsTable {\n  --border: 1px solid rgba(0, 0, 0, 0.15);\n  width: 100%;\n  min-height: calc(100vh - var(--header-height));\n\n  table {\n    --sp-table-header-bg: var(--bs-secondary-subtle);\n    background-color: #fff;\n    border-width: 1px 0;\n\n    .TableRow {\n      display: flex;\n      width: 100%;\n      + .TableRow {\n        border-top: var(--border);\n      }\n\n      &.TableRow-Header {\n        border-bottom: var(--border);\n        .TableCell-Content {\n          display: flex;\n          justify-content: center;\n          align-items: center;\n        }\n      }\n\n      .TableCell {\n        flex: 1;\n        min-width: 7rem;\n        &.SELECT {\n          flex: 0 0 3rem;\n          min-width: unset;\n        }\n        &.NAME {\n          flex: 1.5;\n        }\n        + .TableCell {\n          border-left: var(--border);\n        }\n        .TableCell-Content {\n          padding: 0.35rem;\n          align-content: center;\n          text-align: center;\n          white-space: nowrap;\n          overflow: hidden;\n          text-overflow: ellipsis;\n          font-weight: 700;\n        }\n      }\n    }\n  }\n  .Table-Controls {\n    margin-right: 0.5rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
